var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeBlob = function SvgTimeBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.99 0C3.466 0 0 6.071 0 11.591S4.34 20 9.875 20s9.088-4.559 10.017-10.002C20.91 4.059 14.554 0 8.989 0Zm4.51 13.185L9.148 9.998s.146-5.939.146-6.375l1.888-.726-.146 6.234 3.339 2.751-.873 1.303Z"
  })));
};
export default SvgTimeBlob;